import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  AnimateModule,
  GtmClickDirective,
  HeaderComponent,
  NewsletterComponent,
  WwwAppState,
  WwwRouteSlug,
} from '@pro-connect/shared';
import { PillarContactBarComponent } from './components/pillar-contact-bar/pillar-contact-bar.component';
import { PillarTopComponent } from './components/pillar-top/pillar-top.component';
import { HomePillarsComponent } from '../../../home/components/home-pillars/home-pillars.component';
import { select } from '@ngxs/store';
import { PillarIntroComponent } from './components/pillar-intro/pillar-intro.component';
import { PillarTilesComponent } from './components/pillar-tiles/pillar-tiles.component';
import { PillarSliderComponent } from './components/pillar-slider/pillar-slider.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-pillar',
  templateUrl: './pillar.component.html',
  styleUrls: ['./pillar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    AnimateModule,
    NewsletterComponent,
    PillarTopComponent,
    PillarContactBarComponent,
    HomePillarsComponent,
    HeaderComponent,
    PillarIntroComponent,
    PillarTilesComponent,
    PillarSliderComponent,
    RouterModule,
    GtmClickDirective,
  ],
})
export class PillarComponent {
  public user = select(WwwAppState.user);
  public bannerUrl = input.required<string>();
  public bannerMobUrl = input.required<string>();
  public introText = input.required<string>();
  public tiles = input.required<{ img: string; title: string; desc: string }[]>();
  public slides = input.required<string[]>();
  public btn = input<{ text: string; url: string } | null>();
  public readonly WwwRouteSlug = WwwRouteSlug;

  constructor() {}
}
